module.exports = __webpack_public_path__ + "img/corrugatedBox15.5b64d207.jpg";